// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const google: any;

import { AfterViewInit, Component, inject } from '@angular/core';

import {
  AuthService,
  GOOGLE_ACCOUNTS_CLIENT_ID,
  GoogleUserCredentials,
  Token,
} from '@coworkrz/auth/data-access';
import { LOCATION_TOKEN } from '@coworkrz/shared/misc';
import { loadScript } from '@coworkrz/core/helpers/js';
import { finalize } from 'rxjs';
import { ProgressBarComponent } from '@coworkrz/shared/ui';

@Component({
  selector: 'app-feature-sign-in',
  imports: [ProgressBarComponent],
  templateUrl: './sign-in.component.html',
})
export class SignInComponent implements AfterViewInit {
  private auth = inject(AuthService);
  private googleAccountsClientId = inject(GOOGLE_ACCOUNTS_CLIENT_ID);
  private location = inject<Location>(LOCATION_TOKEN);

  loading = false;
  errors = '';

  ngAfterViewInit(): void {
    this.loadGoogleSignInButton();
  }

  /**
   * Loads the Google Sign Up button and initializes the Google Sign-In API.
   * @private
   */
  private loadGoogleSignInButton(): void {
    loadScript('https://accounts.google.com/gsi/client', () => {
      google.accounts.id.initialize({
        client_id: this.googleAccountsClientId,
        context: 'signin',
        ux_mode: 'popup',
        cancel_on_tap_outside: true,
        callback: (credentials: GoogleUserCredentials) => {
          this.signinWithGoogle(credentials);
        },
      });

      const button = document.getElementsByClassName(
        'g_id_signin'
      )[0] as HTMLElement;
      const title = document.getElementsByTagName('h1')[0] as HTMLElement;

      if (title) {
        google.accounts.id.renderButton(button, {
          text: 'signin_with',
          size: 'large',
          width: title.clientWidth,
          shape: 'pill',
          theme: 'filled_blue',
        });
      }
    });
  }

  private signinWithGoogle(credentials: GoogleUserCredentials): void {
    this.loading = true;
    this.errors = '';
    this.auth
      .authenticateWithGoogle(credentials)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: (token: Token) => {
          this.auth.login(token);
          this.location.assign('/');
        },
        error: (error) => {
          switch (error.status) {
            case 401:
              this.errors = "Sorry you don't have access to this application.";
              break;
            default:
              this.errors = 'An error occurred. Please try again.';
              break;
          }
        },
      });
  }
}
